import { create } from "zustand";
import { useFetchDecryptAuthTokenSlice } from "../slices/AuthTokenSlices/fetchDecryptAuthToken";

interface FetchDecryptAuthTokenInterface
  extends ReturnType<typeof useFetchDecryptAuthTokenSlice> {}

export const AuthTokenStore = create<FetchDecryptAuthTokenInterface>(
  (...a) => ({
    ...useFetchDecryptAuthTokenSlice(...a),
  })
);
